import * as Yup from 'yup';

export const rewardSchema = Yup.object({
  name: Yup.string().required('โปรดระบุชื่อของรางวัล'),
  detail: Yup.string().required('โปรดระบุรายละเอียดของรางวัล'),
  point: Yup.string().required('โปรดระบุคะแนน').matches(/^\d+$/, 'โปรดระบุคะแนนให้ถูกต้อง'),
  value: Yup.string().required('โปรดระบุมูลค่า').matches(/^\d+$/, 'โปรดระบุมูลค่าให้ถูกต้อง'),
  quantity: Yup.string()
    .required('โปรดระบุจำนวนของรางวัลที่แลกต่อความ')
    .matches(/^\d+$/, 'โปรดระบุจำนวนให้ถูกต้อง'),
  unit: Yup.string().required('โปรดระบุหน่วยของรางวัล'),
  stock: Yup.string()
    .required('โปรดระบุจำนวนคงเหลือ')
    .matches(/^\d+$/, 'โปรดระบุจำนวนคงเหลือให้ถูกต้อง'),
  product_size: Yup.string().required('โปรดระบุขนาดของรางวัล'),
  category: Yup.string().required('โปรดระบุประเภทของรางวัล'),
  type_delivery: Yup.string().required('โปรดระบุบริการจัดส่ง'),
});
